import React, { useEffect, useState } from 'react';
import { Box, Typography, LinearProgress, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // State to manage the loading spinner
  const [name, setName] = useState('');
  const [id, setId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const location = useLocation();

  interface UserDataResponse {
    promoterName: string;
    merchantID: string;
  }

  const fetchUserData = async (phoneNumber: string):Promise<UserDataResponse> => {
    try {
      
      const response = await axios.get<UserDataResponse>(`https://promoter-api.benow.in/api/kyc/v1/auth/promoter-info/${phoneNumber}`);
      
      // Update the state with the received data
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      throw error;
      // Optionally, set an error message or handle errors
    }
  };

  useEffect(() => {
    // Parse query parameters from the URL
    const searchParams = new URLSearchParams(location.search);
    const queryMobile = searchParams.get('mobile') || ''; // Default to empty string if not found
    setPhoneNumber(queryMobile);
    // Populate state with query parameters

    // Minimum 3 seconds timer
    const minimumTime = new Promise<void>((resolve) => {
      setTimeout(resolve, 3000); // Wait for at least 3 seconds
    });

    // Combine minimum delay and Axios data fetch
    Promise.all([minimumTime, fetchUserData(queryMobile)])
    .then(([_, userData]: [void, UserDataResponse]) => {
        setLoading(false); // After both tasks are done, set loading to false
        localStorage.setItem('mobile',queryMobile);
        localStorage.setItem('name',userData.promoterName);
        localStorage.setItem('id',userData.merchantID);
        navigate('/otp-verify', {
          state: {
            phone: queryMobile,
            id: userData.merchantID,
            name: userData.promoterName,
          },
        }); // Navigate to /otp-verify after loading is complete
      })
      .catch((error) => {
        setLoading(false); // Ensure loading is false in case of error
        console.error('Error during fetch or minimum time:', error);
      });
  }, [location.search,navigate]);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'white', // Set your background color
      }}
    >
      <Paper
        variant="elevation"
        elevation={6}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: '2rem',
          borderRadius: '8px',
          textAlign: 'center',
          border:'2px solid red'
        }}
      >
        <img src="./assets/BenowLogo2.jpg" width="150" height="auto" alt="Company Logo" />
        {loading && (
          <Box sx={{ width: '100%', mt: 4 }}>
            <Typography variant="subtitle1" sx={{ mt: 2 }}>
              Fetching Details
            </Typography>
            <LinearProgress />
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default Welcome;
